"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalSelectCarBrandList = void 0;
var react_1 = __importStar(require("react"));
var ModalSelectList_module_scss_1 = __importDefault(require("./ModalSelectList.module.scss"));
var selectors_1 = require("../../redux/selectors");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var inStockSlice_1 = require("../../redux/slice/inStockSlice");
var react_redux_1 = require("react-redux");
var ModalSelectCarBrandList = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var filterList = (0, react_redux_1.useSelector)(selectors_1.inStockListSelector).inStockList;
    var loading = (0, react_redux_1.useSelector)(selectors_1.inStockListSelector).stateLoad.isLoad;
    var requestSent = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        if (!filterList.length && !loading && !requestSent.current) {
            requestSent.current = true;
            dispatch((0, inStockSlice_1.inStockListLoader)());
        }
    }, [dispatch, filterList.length, loading]);
    var setBrandFilter = function (configValue) {
        dispatch((0, modalSlice_1.setFilterBrand)(configValue));
    };
    if (loading) {
        return react_1.default.createElement("div", null, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...");
    }
    return (react_1.default.createElement("ul", { className: ModalSelectList_module_scss_1.default.modal_select__list }, filterList.map(function (item) {
        var filter = item;
        return (react_1.default.createElement("li", { className: ModalSelectList_module_scss_1.default.modal_select__item, key: item.brand, onClick: function () {
                return setBrandFilter({
                    nextValue: item.models,
                    status: true,
                    selected: item.brand,
                    thisValue: filterList,
                });
            } },
            filter.brand,
            " ",
            react_1.default.createElement("span", null, filter.total)));
    })));
};
exports.ModalSelectCarBrandList = ModalSelectCarBrandList;
